






















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { getCostByCurrency } from "@/lib/moneyHelpers";
import AvailableContentCount from "@/components/AvailabelContentCount";
import BaseIcon from "@/components/BaseIcon";
import FormatMoney from "@/components/FormatMoney";
import TextClamp from "@/components/TextClamp";

@Component({ name: "LevelItem", components: { FormatMoney, BaseIcon, TextClamp, AvailableContentCount } })
export default class LevelItem extends Vue {
  @Prop({ required: true })
  public readonly priceLevel!: SubscriptionLevel;

  get cost() {
    if (!this.priceLevel.pricePackage) return null;
    return getCostByCurrency(this.priceLevel.pricePackage);
  }

  public get price() {
    return this.cost?.cost ?? 0;
  }

  public get currencyCode() {
    return this.cost?.currency ?? undefined;
  }
}
